<script lang="ts">
	import type { ImageDetails } from "proto/image";
	import LazyBackgroundImage from "./LazyBackgroundImage.svelte";

	export let back: (() => void) | string | undefined = undefined;
	export let name: string = 'Home';
	export let image: ImageDetails | undefined = undefined;

	interface $$Slots {
		info: {};
		default: {};
  }
</script>

<!-- {#if typeof back === 'string'}
	<a href={back} class="button transparent body-m medium back grey">
		<span class="icon-chevron-left-20"></span>
	</a>
{:else if typeof back === 'function'}
	<button on:click={() => back()} class="button transparent body-m medium back grey">
		<span class="icon-chevron-left-20"></span>
	</button>
{/if} -->

<div class="heading flex row align-stretch">

	{#if image}
		<div class="relative">
			<div class="card">
				<LazyBackgroundImage image={image} alt={image?.filename || ''}>
					<slot name="info" />
				</LazyBackgroundImage>
			</div>
		</div>
	{/if}
	<div class="fill-space">
		<slot />
	</div>

</div>